module.exports = __webpack_public_path__ + "img/folder-cloud.44575eb1.svg";